// extracted by mini-css-extract-plugin
export default {"btn-wrap":"MarketsBtn_btn-wrap__3Z+us","btn-store":"MarketsBtn_btn-store__LH+Sx"};